import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guard/auth-guard.guard';
import { LayoutComponent } from './layout/layout.component';
import { authRoutes } from './modules/auth/auth.routes';

export const routes: Routes = [
  {
    path: 'public/report/:reportToken',
    loadChildren: () =>
      import('./modules/public-report/public-report.routes').then((m) => m.publicReportRoutes),
  },
  {
    path: 'auth',
    children: authRoutes,
  },

  // Protected Layout
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: 'kycs',
        loadChildren: () => import('./modules/kycs/kycs.routes').then((m) => m.kycsRoutes),
      },
      {
        path: 'pep-sanctions',
        loadChildren: () =>
          import('./modules/pep-sanctions/pep-sanctions.routes').then((m) => m.pepSanctionsRoutes),
      },
      {
        path: 'parties',
        loadChildren: () => import('./modules/parties/parties.routes').then((m) => m.partiesRoutes),
      },
      {
        path: 'templates',
        loadChildren: () =>
          import('./modules/template/template.routes').then((m) => m.TemplateRoute),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.routes').then((m) => m.settingsRoutes),
      },
      {
        path: 'cases',
        loadChildren: () => import('./modules/cases/cases.routes').then((m) => m.casesRoutes),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./modules/notifications/notifications.routes').then((m) => m.notificationsRoutes),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },

  { path: '**', redirectTo: '' },
];
